export const mapboxPublicToken =
  'pk.eyJ1Ijoiam9uZGFjayIsImEiOiJjajE1Nnloa2cwMG1lMzRvNmZlajdsY3hjIn0.A47aCMtYzJKLRJvB8D2KSQ'
